mainApp.component('slaSettingsKeepalive', {
    templateUrl: '/public/components/configuration/slaSettings/sla-settings-keep-alive-configuration.component.html',
    bindings: {
        model: '=',
        siteId: '<?',
        showOverrideCheckbox: '<?',
    },
    controller: slaSettingsKeepAliveConfigurationController
});


function slaSettingsKeepAliveConfigurationController(SlaSettingService) {
    const ctrl = this;
    ctrl.keepaliveStatus = {
        DEFAULT: "Default - 3 sec",
        CUSTOM: "Custom",
    };

    ctrl.$onChanges = (changes) => {
        if(changes.siteId && ctrl.model) {
            initKeepalives();
        }
    }

    ctrl.disableInput = () => {
        return ctrl.siteId && !ctrl.model?.overrideAccountKeepAliveSettings;
    }

    const initKeepalives = () => {
        ctrl.modelKeepalives = {
            primary: {
                status: getSingleKeepaliveStatus(ctrl.model.primaryKeepAliveInterval),
                setToDefault: () => ctrl.model.primaryKeepAliveInterval = SlaSettingService.DEFAULT_KEEPALIVE_INTERVAL_IN_SEC,
            },
            secondary: {
                status: getSingleKeepaliveStatus(ctrl.model.secondaryKeepAliveInterval),
                setToDefault: () => ctrl.model.secondaryKeepAliveInterval = SlaSettingService.DEFAULT_KEEPALIVE_INTERVAL_IN_SEC,
            },
            lastResort: {
                status: getSingleKeepaliveStatus(ctrl.model.lastResortKeepAliveInterval),
                setToDefault: () => ctrl.model.lastResortKeepAliveInterval = SlaSettingService.DEFAULT_KEEPALIVE_INTERVAL_IN_SEC,
            },
        }
    }

    /**
     *  If the interval is null or is equal to  DEFAULT_KEEPALIVE_INTERVAL_IN_SEC then server/catod will complete the default value
     */
    const getSingleKeepaliveStatus = (keepaliveInterval) => {
        return (!keepaliveInterval || keepaliveInterval === SlaSettingService.DEFAULT_KEEPALIVE_INTERVAL_IN_SEC) ? ctrl.keepaliveStatus.DEFAULT : ctrl.keepaliveStatus.CUSTOM;
    }

};
